module.exports = __webpack_public_path__ + "img/escombros.d4e5d315.png";